<template>
  <div class="rank" ref="scrollWrapper" id="rank">
    <div class="margin-box"></div>
    <div class="title" style="margin-top: 0px">
      <span class="posr">
        <span class="name1">大赛</span>排名
        <img src="../assets/img/double-arrows.png" />
      </span>
    </div>
    <div class="fake-input-box" v-for="(item, index) in fields" :key="index">
      <div class="label">
        <span class="star" v-if="item.required == 1">*</span>
        <span>{{ item.name }}</span>
      </div>
      <div
        class="fake-input"
        v-if="item.property === 'csearch_strategy'"
        @click="onFakeInput(item)"
      >
        <div class="content">
          <span>{{ strategyObj.label }}</span>
        </div>
        <div class="tri"></div>
      </div>
      <div
        :class="['fake-input', isDisabled ? 'disabled' : '']"
        v-if="item.property === 'csearch_scale_group'"
        @click="onFakeInput(item)"
      >
        <div class="content">
          <span>{{ scalegroupObj.label }}</span>
        </div>
        <div class="tri"></div>
      </div>
      <div
        class="fake-input"
        v-if="item.property === 'csearch_rank_range'"
        @click="onFakeInput(item)"
      >
        <div class="content">
          <!-- 拼接 -->
          <span>{{ rangesDateSelctLable.label }}</span>
        </div>
        <div class="tri"></div>
      </div>
      <div class="fake-input" v-if="item.property === 'csearch_fund_name'">
        <input
          type="text"
          placeholder="基金名称/所属机构"
          v-model="searchParmas.csearch_fund_name"
        />
        <i class="find"></i>
      </div>
    </div>
    <div class="margin-box"></div>
    <table border="0" class="rank-table" v-if="tableData.length">
      <tr>
        <th style="width:0.25rem;">排名</th>
        <th>参赛产品</th>
        <th>所属机构</th>
      </tr>
      <!-- <tr class="empty" v-if="!tableData.length">
        <td colspan="11">
          <img src="../assets/img/rank-empty.png" />
          <p>没有符合条件的产品或产品未上榜</p>
        </td>
      </tr> -->
      <tr
        v-for="(item, index) in tableData"
        :key="index">
        <td style="width:0.25rem;" v-if="item.rank_score == 1">
          <img src="../assets/img/rank1.png" alt="">
        </td>
        <td style="width:0.25rem;" v-else-if="item.rank_score == 2">
          <img src="../assets/img/rank2.png"  alt="">
        </td>
        <td style="width:0.25rem;" v-else-if="item.rank_score == 3">
          <img src="../assets/img/rank3.png" alt="">
        </td>
        <td style="width:0.25rem;" v-else>
          <p class="no-wrap" style="width: 0.8rem;">{{ item.rank_score }}</p>
        </td>
        <td>
          <p class="no-wrap" style="width: 2.72rem;">{{ item.fund_name_display || "暂无" }}</p>
        </td>
        <td>
          <p class="no-wrap" style="width: 2.9rem;">{{ item.company_name || "暂无" }}</p>
        </td>
      </tr>
    </table>
    <div class="empty-box" v-if="!tableData.length">
      <img src="../assets/img/m-rank-empty.png" />
      <p>没有符合条件的产品或产品未上榜</p>
    </div>
    <div class="pop-up" v-if="showPopPup">
      <div class="toast">
        <header>
          <div class="left" @click="onCancel">取消</div>
          <div class="right" @click="onConfirm">确认</div>
        </header>
        <div class="content">
          <div class="pop-up-slot">
            <div class="title">
              <span v-if="showPopPupContent.item.required == 1">*</span
              >{{ showPopPupContent.item.name }}
            </div>
            <div
              class="pop-up-item-box"
              v-if="showPopPupContent.item.property === 'csearch_strategy'"
            >
              <div
                :class="[
                  'item',
                  'itemStrategy',
                  popStrategyActive.value == item.value ? 'active' : '',
                ]"
                v-for="(item, index) in showPopPupContent.itemArr"
                :key="index"
                style="width: calc((100% - 0.35rem) / 2); margin-right: 0.35rem"
                @click="onSelectStrategy(item)"
              >
                {{ item.label }}
              </div>
            </div>
            <div
              class="pop-up-item-box"
              v-if="showPopPupContent.item.property === 'csearch_scale_group'"
            >
              <div
                :class="[
                  'item',
                  popScalegroupActive.value == item.value ? 'active' : '',
                ]"
                style="width: 100%; margin-right: 0.35rem"
                v-for="(item, index) in showPopPupContent.itemArr"
                :key="index"
                @click="onSelectProd(item)"
              >
                {{ item.label }}
              </div>
            </div>
            <div
              class="pop-up-item-box"
              v-if="showPopPupContent.item.property === 'csearch_rank_range'"
            >
              <div>
                <div
                  :class="[
                    'item',
                    popRankrangeActive.value == item.value ? 'active' : '',
                  ]"
                  v-for="(item, index) in showPopPupContent.itemArr"
                  :key="index"
                  @click="onSelectRang(item)"
                >
                  {{ item.label }}
                </div>
              </div>
              <div>
                <div
                  :class="[
                    'item',
                    rangesDateActive == subIndex ? 'active' : '',
                  ]"
                  v-for="(subItem, subIndex) in rangesDate"
                  :key="subIndex"
                  @click="onSelectRangDate(subIndex, subItem)"
                >
                  {{ subItem.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tips">
      <p>备注说明</p>
      <span
        >过了报名有效期参赛的产品除了不参与当月排名，其他榜单均参与数据报送不全的产品不参与排名</span
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { dataResult } from "@/lib/data.js";
export function debounce(func, delay) {
  let timer;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}
export default {
  data() {
    return {
      fields: [],
      strategy: [], // 策略类型
      prods: [],
      ranges: [], // 排名周期
      rangesDate: [], // 排名周期时间
      rangesDateActive: 0,
      rangesDateSelctLable: {
        label: "",
        date: "",
        dateIndex: "",
      },
      isShow: true,
      showPopPup: false,
      showPopPupContent: null,
      searchParmas: {
        match_code: "shenwanjm",
        channel: "shenwanjm",
        csearch_strategy: 1,
        csearch_scale_group: 2,
        csearch_rank_range: "1m",
        csearch_end_date: "",
        csearch_fund_name: "",
        page: 1,
        rows: 10,
      },
      popStrategyActive: {
        value: 1,
        label: "权益组",
      },
      popScalegroupActive: {
        // value: 1,
        // label: "小资产规模组(500万-5000万元)",
        value: 2,
        label: "大资产规模组(5000万元以上)",
      },
      popRankrangeActive: {
        value: "1m",
        label: "月度榜单",
      },
      strategyObj: {
        value: 1,
        label: "权益组",
      },
      scalegroupObj: {
        // value: 1,
        // label: "小资产规模组(500万-5000万元)",
        value: 2,
        label: "大资产规模组(5000万元以上)",
      },
      rankrangeObj: {
        value: "1m",
        label: "月度榜单",
      },
      isDisabled: false,
      tableData: [],
      scroll: null,
      totalPage: 0
    };
  },
  created() {
    this.init();
    this.onKeyupSearch();
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.scroll) {
        this.scroll = this.$refs.scrollWrapper
        this.scroll.onscroll = () => {
          const scrollTop = this.scroll.scrollTop
          const clientHeight = this.scroll.clientHeight
          const scrollHeight = this.scroll.scrollHeight
          if ( Math.round(scrollTop) + clientHeight == scrollHeight ) {
            if ( this.totalPage > 3 ) {
              if ( this.searchParmas.page <= 3 ) {
                this.getTableList(this.searchParmas)
              }
            } else {
              if ( this.searchParmas.page <= this.totalPage ) {
                this.getTableList(this.searchParmas)
              }
            }
          }
        }
      }
     
    })
  },
  methods: {
    init() {
      /*
        axios
          .get(
            "https://activity.simuwang.com/backend/api/competition/getRankSearchFields",
            {
              params: {
                match_code: "shenwanjm",
              },
            }
          )
          .then((resp) => {
            if (resp.status == 200) {
              var result = resp.data.data;
              console.log(result);
              this.fields = result.fields.filter(
                (item) => item.property !== "csearch_end_date"
              );
              // 策略类型
              // var strategy = result.option_definition.csearch_strategy
              // this.strategy = strategy.length && strategy.map((item) => {
              //   if (item.label.indexOf('&') > -1) {
              //     item.label = item.label.split('&')
              //   } else {
              //     item.label = [item.label]
              //   }
              //   return item
              // })
              this.strategy = result.option_definition.csearch_strategy
              this.prods = this.strategy[0]["children"]
              this.ranges = result.option_definition.csearch_rank_range
              this.getTableList(this.searchParmas)
            }
          });
      */
      var result = dataResult;
      this.fields = result.fields.filter(
        (item) => item.property !== "csearch_end_date"
      );
      this.strategy = result.option_definition.csearch_strategy;
      this.prods = this.strategy[0]["children"];
      this.ranges = result.option_definition.csearch_rank_range;
      this.rangesDate = this.ranges[0]["children"]; // 排名周期时间
      this.rangesDateSelctLable = {
        label: "",
        date: "",
        dateIndex: "",
      };
      if (this.rangesDate && this.rangesDate.length) {
        this.searchParmas.csearch_end_date = this.rangesDate[0]["value"];
        this.rangesDateActiveLabel = this.rangesDate[0]["label"];
        this.rangesDateSelctLable.label =
          this.rankrangeObj.label + ">" + this.rangesDateActiveLabel;
        this.rangesDateSelctLable.date = this.rangesDateActiveLabel;
        this.rangesDateSelctLable.dateIndex = 0;
      } else {
        this.searchParmas.csearch_end_date = "";
        this.rangesDateSelctLable.label = this.rankrangeObj.label;
      }
      this.getTableList(this.searchParmas);
    },
    // 点击显示弹窗
    onFakeInput(item) {
      if (this.isDisabled && item.property == "csearch_scale_group") {
        return (this.showPopPup = false);
      }
      this.showPopPup = true;
      var showContent = {
        item: null,
        itemArr: null,
      };
      showContent.item = item;
      if (item.property == "csearch_strategy") {
        showContent.itemArr = this.strategy;
        this.popStrategyActive = JSON.parse(JSON.stringify(this.strategyObj));
      } else if (item.property == "csearch_scale_group") {
        showContent.itemArr = this.prods;
        this.popScalegroupActive = JSON.parse(
          JSON.stringify(this.scalegroupObj)
        );
      } else if (item.property == "csearch_rank_range") {
        showContent.itemArr = this.ranges;
        this.rangesDate = [];
        this.ranges.forEach((rang) => {
          if (rang.value == this.rankrangeObj.value) {
            this.rangesDate = rang.children;
            this.rangesDate.forEach((cItem, cIndex) => {
              if (cItem.label == this.rangesDateSelctLable.date) {
                this.rangesDateActive = cIndex;
              }
            });
          }
        });
        this.popRankrangeActive = JSON.parse(JSON.stringify(this.rankrangeObj));
      }
      this.showPopPupContent = showContent;
    },
    // 弹窗取消
    onCancel() {
      this.showPopPup = false;
    },
    // 弹窗确定
    onConfirm() {
      this.showPopPup = false;
      this.searchParmas.page = 1;
      // 设置值
      if (this.showPopPupContent.item.property == "csearch_strategy") {
        this.searchParmas.csearch_strategy = this.popStrategyActive.value;
        this.strategyObj = JSON.parse(JSON.stringify(this.popStrategyActive));
        var itemArr = this.showPopPupContent.itemArr;
        itemArr.forEach((item) => {
          if (item.value == this.strategyObj.value) {
            if (item.children.length) {
              this.isDisabled = false;
              this.prods = item.children;
              this.searchParmas.csearch_scale_group = this.prods[0].value;
              this.popScalegroupActive = this.prods[0];
              this.scalegroupObj = this.prods[0];
            } else {
              this.isDisabled = true;
              this.searchParmas.csearch_scale_group = "";
              this.popScalegroupActive = {
                value: null,
                label: null,
              };
              this.scalegroupObj = {
                value: null,
                label: null,
              };
            }
          }
        });
      } else if (
        this.showPopPupContent.item.property == "csearch_scale_group"
      ) {
        this.searchParmas.csearch_scale_group = this.popScalegroupActive.value;
        this.scalegroupObj = JSON.parse(
          JSON.stringify(this.popScalegroupActive)
        );
      } else if (this.showPopPupContent.item.property == "csearch_rank_range") {
        this.searchParmas.csearch_rank_range = this.popRankrangeActive.value;
        this.rangesDateSelctLable = {
          label: "",
          date: "",
          dateIndex: "",
        };
        if (this.rangesDateActiveLabel) {
          this.rangesDateSelctLable.label =
            this.popRankrangeActive.label + ">" + this.rangesDateActiveLabel;
          this.rangesDateSelctLable.date = this.rangesDateActiveLabel;
          this.rangesDateSelctLable.dateIndex = this.rangesDateActive;
        } else {
          this.rangesDateSelctLable.label = this.popRankrangeActive.label;
        }
        this.rankrangeObj = JSON.parse(JSON.stringify(this.popRankrangeActive));
      }
      this.getTableList(this.searchParmas);
    },
    onSelectStrategy(item) {
      this.popStrategyActive.value = item.value;
      this.popStrategyActive.label = item.label;
    },
    onSelectProd(item) {
      this.popScalegroupActive.value = item.value;
      this.popScalegroupActive.label = item.label;
    },
    onSelectRang(item) {
      this.rangesDateActive = 0;
      this.popRankrangeActive.value = item.value;
      this.popRankrangeActive.label = item.label;
      if (item.children && item.children.length) {
        this.rangesDate = item.children;
        this.searchParmas.csearch_end_date = this.rangesDate[0]["value"];
        this.rangesDateActiveLabel = this.rangesDate[0]["label"];
      } else {
        this.rangesDate = [];
        this.searchParmas.csearch_end_date = "";
        this.rangesDateActiveLabel = "";
      }
    },
    // 选择当前时间
    onSelectRangDate(index, item) {
      this.rangesDateActive = index;
      this.rangesDateActiveLabel = item.label;
      this.searchParmas.csearch_end_date = item.value;
    },
    // 输入搜索
    onKeyupSearch() {
      this.$watch(
        "searchParmas.csearch_fund_name",
        debounce(() => {
          this.searchParmas.page = 1
          this.getTableList(this.searchParmas);
        }, 1000)
      );
    },
    // 获取表格数据
    getTableList(params) {
      console.log(params);
      var searchParams = {
        strategyType: "",
        group: "",
        date: "",
        type: "",
        keywork: "",
        pageIndex: 0,
        pageSize: 0,
      };
      // var year = new Date().getFullYear()
      // var month = (Number(new Date().getMonth()) + 1) >= 10 ? (Number(new Date().getMonth()) + 1) : '0' + (Number(new Date().getMonth()) + 1)
      searchParams.date = this.searchParmas.csearch_end_date;
      searchParams.strategyType = this.strategyObj.label || "";
      if (this.scalegroupObj.label) {
        var index = this.scalegroupObj.label.indexOf("(");
        searchParams.group = this.scalegroupObj.label.substring(0, index);
      } else {
        searchParams.group = "";
      }
      searchParams.type = this.rankrangeObj.label || "";
      searchParams.keywork = params.csearch_fund_name;
      searchParams.pageIndex = params.page;
      searchParams.pageSize = params.rows;
      // axios.post("http://10.222.21.157:6009/api/SWHY/querymatchranking",searchParams)
      //   .then((resp) => {
      //     if (resp.status == 200) {
      //       this.tableData = resp.data.datas
      //       this.count = resp.data.total
      //       this.total_page = this.pageTotal(this.total, 10)
      //     }
      // });
      axios
        .get(
          "https://activity.simuwang.com/backend/api/competition/commonRankList",
          {
            params,
          }
        )
        .then((resp) => {
          console.log(resp);
          let resultData = resp.data.data.data
          this.totalPage = resp.data.data.pager.total_page
          if ( resultData && resultData.length ) {
            if (this.searchParmas.page == 1) {
              this.tableData = resultData
            } else {
              this.tableData = [...this.tableData, ...resultData]
            }
            this.searchParmas.page += 1
          } else {
            this.tableData = []
          }
        });
    },
    // 计算总页数
    pageTotal(rowCount, pageSize) {
      if (rowCount == null || rowCount == "") {
        return 0;
      } else {
        if (pageSize != 0 && rowCount % pageSize == 0) {
          return parseInt(rowCount / pageSize);
        }
        if (pageSize != 0 && rowCount % pageSize != 0) {
          return parseInt(rowCount / pageSize) + 1;
        }
      }
    },
    pageCallback(page) {
      this.searchParmas.page = page;
      this.getTableList(this.searchParmas);
    },
  },
};
</script>

<style lang="less" scoped>
.rank {
  // height: 100%; 
  height: 100vh; 
  overflow-y: scroll;
  // overflow: hidden;
  padding-top: 0.88rem;
  background-color: #fff;
  .margin-box {
    width: 100%;
    height: 0.2rem;
    background: #eee;
  }
  .posr {
    position: relative;
  }
  .title {
    position: relative;
    color: #333;
    font-size: 0.38rem;
    line-height: 1rem;
    font-weight: 700;
    padding-left: 0.34rem;
    margin-bottom: 0.5rem;
    margin-top: 0.2rem;
    border-bottom: 1px solid #bbbbbb;
    .name1 {
      color: #136bd7;
    }
    img {
      width: 0.33rem;
      margin-left: 0.1rem;
    }
  }
  .fake-input-box {
    margin-bottom: 0.6rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-left: 0.3rem;
    margin-right: 0.4rem;
    .label {
      width: 1.46rem;
      font-size: 0.26rem;
      font-weight: bold;
      line-height: 1;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: start;
      -ms-flex-align: start;
      align-items: flex-start;
      .star {
        color: #f45;
      }
    }
    .fake-input {
      -webkit-box-flex: 1;
      -ms-flex-positive: 1;
      flex-grow: 1;
      height: 1rem;
      border: 0.02rem solid #d7dae2;
      border-radius: 0.1rem;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      padding: 0 0.2rem;
      .tri {
        width: 0;
        height: 0;
        border-top: 0.2rem solid #999;
        border-left: 0.15rem solid transparent;
        border-right: 0.15rem solid transparent;
      }
      &.disabled {
        background-color: #f1f1f1;
      }
    }
  }
  .empty-box {
    width: 100%;
    height: 4rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 1rem;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    img {
      width: 1.17rem;
      height: 0.98rem;
      margin-bottom: 0.4rem;
    }
    p {
      text-align: center;
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
    }
  }
  .tips {
    margin-bottom: 0.8rem;
    padding: 0 0.3rem;
    font-size: 0.24rem;
    color: #333;
    line-height: 0.4rem;
  }
  .list-title {
    padding: 0.3rem 0.15rem;
    padding-left: 0.1rem;
    // text-align: center;
    text-align: left;
    padding-left: 0.45rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      width: 1.5rem;
    }
    span.list-title-left {
      width: 1rem;
      background: red;
    }
    span.list-title-center {
      width: 2.5rem;
      background: green;
    }
    span.list-title-right {
      width: 2rem;
      background: blue;
    }
  }
  .list-content {
    padding: 0 0.15rem;
    padding-left: 0.1rem;
    // padding-left: 0.45rem;
    .list-item {
      text-align: center;
      // text-align: left;
      padding: 0.3rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        width: 1.45rem;
      }
      span.list-item-center {
        width: 2.5rem;
        background: green;
        text-align: left;
        line-height: 0.4rem;
      }
      span.list-item-right {
        // width: 2rem;
        width: 2rem;
        background: blue;
        line-height: 0.4rem;
        text-align: left;
      }
    }
  }
  table {
    table-layout:fixed;
    border-collapse: collapse;
    border: 0.02rem solid #BFE5FF;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 0.2rem;
    overflow: hidden;
    font-size: 0.24rem;
    th {
      font-weight: bold;
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: left;
      border-right: 0.02rem solid #BFE5FF;
      border-bottom: 0.02rem solid #BFE5FF;
    }
    tr:nth-child(1) {
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
    }
    td {
      height: 0.8rem;
      max-height: 0.8rem;
      font-weight: 400;
      line-height: 0.6rem;
      border-right: 0.02rem solid #BFE5FF;
      border-bottom: 0.02rem solid #BFE5FF;
      text-align: left;
      img {
        display: block;
        margin: 0 auto;
        width: 0.4rem;
      }
      .no-wrap {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &.rank-table {
      margin: 0.5rem 0.3rem;
      tr > *:nth-child(1) {
        text-align: center;
        width: 0.8rem;
      }
      tr > *:nth-child(2) {
        padding-left: 0.2rem;
        width: 2.72rem;
      }
      tr > *:nth-child(3) {
        padding-left: 0.2rem;
        width: 2rem;
      }
      tr:nth-child(1) {
        background: rgba(19, 107, 215, 0.1);
      }
    }
  }
}
.pop-up {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  background: rgba(60, 60, 60, 0.8);
  .toast {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 6.85rem;
    background: #fbfbfb;
    header {
      width: 100%;
      height: 1rem;
      background: #fff;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      padding: 0 0.3rem;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      font-size: 0.3rem;
      color: #2992ff !important;
      line-height: 0;
    }
    .content {
      padding: 0.5rem 0.3rem 0.3rem;
      max-height: calc(100% - 1rem);
      overflow-y: auto;
    }
  }
  .pop-up-slot {
    font-size: 0.26rem;
    .title {
      font-weight: bold;
      line-height: 1;
      margin-bottom: 0.1rem;
      border: none;
      font-size: 0.26rem;
      padding-left: 0;
      span {
        color: #ff4455;
      }
    }
    .pop-up-item-box {
      margin: 0 0.1rem;
      .item {
        display: inline-block;
        width: calc((100% - 0.35rem * 2) / 3);
        height: 0.7rem;
        line-height: 0.7rem;
        text-align: center;
        background: #fbfbfb;
        border: 1px solid #d7dae2;
        border-radius: 0.2rem;
        margin-top: 0.2rem;
        margin-right: 0.35rem;
        &:nth-child(3n) {
          margin-right: 0;
        }
        &.itemStrategy:nth-child(2n) {
          margin-right: 0 !important;
        }
        &.active {
          color: rgb(255, 255, 255) !important;
          background: rgb(19, 107, 215) !important;
        }
      }
    }
  }
}
</style>